import styled, { css } from 'styled-components'

import { color, media, radius, spacing } from '../../themes'

export const Container = styled.div`
  touch-action: none;
  pointer-events: none;
  position: relative;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`

interface CarouselContainerProps {
  itemCount: number
}

export const CarouselContainer = styled.div<CarouselContainerProps>`
  width: calc(100% * ${({ itemCount }) => itemCount});
  height: 100%;
  display: flex;
  align-items: center;
`

interface ItemProps {
  itemCount: number
  translateX: number
  height?: number | string
}

export const Item = styled.div<ItemProps>`
  position: relative;
  width: calc(100% / ${({ itemCount }) => itemCount});
  transition: transform 0.2s ease;
  transform: translateX(${({ translateX }) => translateX}%);
  pointer-events: all;

  ${({ height }) =>
    height
      ? css`
          height: ${typeof height === 'number' ? `${height}px` : height};
        `
      : css`
          height: 70vh;
          max-height: 276px;

          ${media.tablet} {
            max-height: 366px;
          }

          ${media.pc} {
            max-height: 456px;
          }
        `}

  & > * {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    user-select: none;
    -webkit-user-drag: none;
  }
`

interface ArrowButtonProps {
  left?: boolean
}

export const ArrowButton = styled.button<ArrowButtonProps>`
  position: absolute;
  z-index: 2;
  display: none;
  background: rgba(0, 0, 0, 0.55);
  height: 48px;
  width: 48px;
  color: ${color('white')};
  border-radius: ${radius('full')};
  cursor: pointer;
  pointer-events: all;

  ${media.tablet} {
    /* SVG アイコンをボタン円内の中央に配置する (block だとベースライン分ずれる) */
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
  }

  ${({ left }) =>
    left
      ? css`
          left: ${spacing(2)};
        `
      : css`
          right: ${spacing(2)};
        `}
`

interface BulletsContainerProps {
  itemCount: number
}

export const BulletsContainer = styled.div<BulletsContainerProps>`
  position: absolute;
  bottom: ${spacing(4)};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing(2)};
  width: 100%;
`

interface BulletProps {
  active: boolean
}

export const Bullet = styled.span<BulletProps>`
  width: 6px;
  height: 6px;
  background-color: ${color('gray.06')};
  border-radius: ${radius('full')};
  cursor: pointer;
  transition: background-color 400ms ease-out;

  ${({ active }) =>
    active &&
    css`
      background-color: ${color('red.01')};
    `}
`
